export const RECS_MVT_HEADER_NAME = "asos-mvt-id";
export const RECS_MVT_BUCKET_V2 = "v2";
export const RECS_MVT_BUCKET_V3 = "v3";
export const RECS_MVT_GUID_PARAM_NAME = "CustomerGuid";
export const RECS_MVT_CHANNEL_PARAM_NAME = "tst-search-recs";
export const RECS_MVT_CHANNEL_PARAM_VALUE = "web";
export const IDENTITY_COOKIE_NAME = "asos-perx";
